var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8 11.0583L17.575 15.8333L16.3333 17.075L11.5583 12.3C10.6667 12.9417 9.59167 13.3333 8.41667 13.3333C5.425 13.3333 3 10.9083 3 7.91667C3 4.925 5.425 2.5 8.41667 2.5C11.4083 2.5 13.8333 4.925 13.8333 7.91667C13.8333 9.09167 13.4417 10.1667 12.8 11.0583ZM8.41667 4.16667C6.34167 4.16667 4.66667 5.84167 4.66667 7.91667C4.66667 9.99167 6.34167 11.6667 8.41667 11.6667C10.4917 11.6667 12.1667 9.99167 12.1667 7.91667C12.1667 5.84167 10.4917 4.16667 8.41667 4.16667Z",
    fill: "#FCFEFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarSearchIcon);
export default __webpack_public_path__ + "static/media/sidebar_search_icon.84b3bd991d575d65eef253d45210c25b.svg";
export { ForwardRef as ReactComponent };